module.exports = __webpack_public_path__ + "img/Group 947.2ecfa086.png";